<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token')){
          this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }

  },
  created(){
    this.getBaseInfo();
  }
}
</script>

<style>
body .van-toast {
  font-size: 16px;
  padding: 15px;
  line-height: 1.3;
  width: 80%;
  max-width: 500px;
}
body .van-toast .van-toast__icon {
  font-size: 16px;
}
*, :after, :before {
  box-sizing: border-box;

}
.van-toast {
  word-break: keep-all!important;
}
</style>
